import React from "react";
import Image from "next/image";
import styles from "@/components/CustomComponents/ThreeImageRevolution/index.module.scss";
import { getLinkTarget } from "@/utils/helper";

export default function ThreeImageRevolution(props) {
  const { cards: features = [] } = props;

  return (
    <section className={styles.wrapper}>
      <div className="mx-auto px-4">
        <div className="grid grid-cols-3 gap-1 md:gap-8 lg:gap-10 text-center mx-10 md:mx-0">
          {features.map((card, index) => {
            const {
              fields: { title, description, image, url: youtubeUrl } = {},
            } = card ?? {};

            const { fields: { imageUrl, src, altText, assets } = {} } =
              image ?? {};
            const { fields: { file } = {} } = assets?.[0] ?? {};
            const { url: assetUrl } = file ?? {};

            const content = (
              <div className="text-center mx-auto">
                <div className="flex justify-center items-center mb-4 cursor-pointer">
                  <Image
                    src={imageUrl || assetUrl}
                    alt={altText || "Card Image"}
                    width={0}
                    height={0}
                    className="w-full h-auto object-cover card "
                  />
                </div>

                <p className="text-sx mb-2 text-heading">{title}</p>

                <p className="text-gray-700 text-sm leading-relaxed text-description">
                  {description}
                </p>
              </div>
            );

            return (
              <React.Fragment key={index}>
                {youtubeUrl ? (
                  <a
                    href={youtubeUrl}
                    target={getLinkTarget(youtubeUrl)}
                    rel="noopener noreferrer"
                    className="block !no-underline"
                  >
                    {content}
                  </a>
                ) : (
                  content
                )}

                {(index + 1) % 3 === 0 && (
                  <hr className="col-span-3 koh-horizontalrule-block koh-horizontalrule-cwidth" />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
}
